import React, { useContext, useEffect, useState } from "react";
import KeysContainer from "../components/servicesComponents/KeysContainer";
import ServicesContainer from "../components/servicesComponents/ServicesContainer";
import classes from "./EditServices.module.scss";
import classes2 from "../components/servicesComponents//ServicesTable.module.scss";
import { Collapse, Container, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Helmet } from "react-helmet";
import ServicesTable2 from "../components/servicesComponents/servicesTable/ServicesTable2";
import { DDD, E2Data } from "../lib/ddd/ddd";
import Cookies from 'js-cookie'
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { OrgIdContext } from "../store/orgId_context";
import { useQuery } from "@tanstack/react-query";
import DevicesTable from "../components/servicesComponents/devices/devicesTable";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useTranslation } from "react-i18next";
import GenericModal from "../components/UI/GenericModal";
import { useForm } from "react-hook-form";
import { GenericTooltip } from "../components/integrationWizard/form/GenericTooltip";
import Button from "../components/UI/Button";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const Devices = () => {
    const [descriptionCollapse, setDescriptionCollapse] = useState(false);
    const { integrationDevice, aboutOrgId, sessionInfo} = useContext(OrgIdContext);
    const [showNewWindow, setShowNewWindow] = useState(false);
    const [refetchDevices, setRefetchDevices] = useState(0);
    const {t} = useTranslation();

    const {
        register,
        reset,
        formState: { errors },
        handleSubmit,
        control,
        setValue,
        getValues,
    } = useForm();

    const onCreateNewDeviceClick = () =>{
        setShowNewWindow(true);
    }

    const createDeviceSubmit = (data) =>{
        console.log(data);
        data.AssignedTo = "CKT";
        data.DeviceConnected = true;
        data.Mode = "TEST";
        data.SoftwareId = "e2add307-a138-11ec-90fb-faa8f752a7b9";
        data.OrgId = aboutOrgId;
        const e2Data = new E2Data("VP_DevicesOrgUnits");
        e2Data.values = data;
        e2Data.Create().then((res) => {
            console.log(res);
            setRefetchDevices((e) => e+1);
        });
        setShowNewWindow(false);
    }


    return (
    <>
      <Helmet>
        <title>Presets | DDD Invoices</title>
      </Helmet>
      <div className={`h-100 w-100 p-5 ${classes.container}`}>
        <div className={`${classes["panel"]}`}>
           <div className={`${classes["desc-title"]} mb-2 fw-bold d-flex`} onClick={() => setDescriptionCollapse((e) => !e)}>
                <DisplaySettingsIcon className="me-2"/>
                What are Presets/Devices?
                <div className={`ms-auto`}>{descriptionCollapse ? <KeyboardArrowDownIcon className={`${classes["yolo"]}`}/> : <KeyboardArrowLeftIcon className={`${classes["yolo"]}`}/>}</div>
            </div>
           <Collapse in={descriptionCollapse}>
           <div>
                <div className="mb-4">A device serves multiple purposes, including identifying the source of invoices, providing default settings 
                    for recurring values, and optionally acting as an authorization identifier with our services. Therefore it can be thought of as a physical
                    device or just as a virtual collection of preset values. Devices can be tailored to
                    specific needs, allowing for easy filtering of invoices by origin and setting predefined configurations for consistent use:</div>
                <ol className={`${classes["devices-ol"]}`}>
                    <li className="">They are used to identify the source of the invoice</li>
                    <div className="">
                        Whenever you wish to later learn where an invoice originated from your end (person/device/computer) you can assign each of those its
                        own device and later on you can filter invoices based on the device they were created from.
                    </div>
                    <li>They are used as default settings (ie presets)</li>
                        <div>When you're sending us your invoices, some values that are seldom to change, have to be accompanied. Depending on your needs, these values
                            might be static and never changing. In this case, you can set these values as defaults under a device (ie Wholesale vs Retail).
                        </div>
                    <li>They <u>can</u> used as identifications with our services</li>
                        <div>If marked correctly, such devices can also be used as authorization devices with our services</div>
                    <li>Fiscalization</li>
                        <div>When a state requires that information about the device, unit or operator has to be accompanied when performing fiscalization.</div>
                </ol>
           </div>
           </Collapse>
        </div>
        <div className={`${classes["integration-full-title"]} d-flex`}>
            <div>My devices</div>
            <div className="ms-auto">
                <OverlayTrigger placement="top" overlay={<Tooltip>{t("Create new Device/Preset")}</Tooltip>}>
                    <AddCircleIcon className={classes["add-new-button"]} onClick={onCreateNewDeviceClick}/>
                </OverlayTrigger>
            </div>
            <GenericModal show={showNewWindow} onHide={() => setShowNewWindow(null)} title={t("Enter name")} size="sm">
            <form className={classes2["input-container"]} onSubmit={handleSubmit(createDeviceSubmit)}>
                <div>
                    <div key={"InternalName"} className={`${classes2["input-group"]} mt-1`}>
                        <label>
                            {t("Name")}<span className="text-danger">*</span>
                            <GenericTooltip tooltip={""} fieldName={"InternalName"} placement="left"/>
                        </label>
                        <input {...register("InternalName", {required:true})} type={"text"} />
                        {errors["InternalName"] && <span className="text-danger mt-1">{t("This field is required")}</span>}
                    </div>
                    <hr/>
                </div>
                <div className="text-center w-100">
                    <Button type="submit" className="px-5 py-1 ms-3" >
                        {t("Create")}
                    </Button>
                </div>
            </form>
            </GenericModal>
        </div>
        <DevicesTable refetchDevices={refetchDevices}/>
      </div>
    </>
    );
};

export default Devices;
